// extracted by mini-css-extract-plugin
export default {"customCard":"JoinOurTeam_customCard__-sQHO","customBadge":"JoinOurTeam_customBadge__vTxsd","customcount":"JoinOurTeam_customcount__Y5MTH"};